import React, { FC } from 'react'
import { MediaFieldType, LinkFieldType } from '@magal/models'
import { Container, Media, SectionWrap } from '@magal/components'
import { styled } from '@magal/styles'

const Root = styled(Container, {
  color: '$green_09',
  display: 'grid',
  gap: '$32',
  marginLeft: '0',
  marginRight: '0',
  '@lg': {
    gridAutoColumns: '1fr',
    marginLeft: '$containerMarginDesktop',
    marginRight: '$containerMarginDesktop',
  },
})

const Title = styled('h1', {
  projectFont: 'caps01',
  maxWidth: '$maxWidthS',
  marginLeft: '$containerMarginMobile',
  '@lg': {
    marginLeft: 0,
  },
})

const ImageContainer = styled('div', {})

const StyledMedia = styled('div', {
  display: 'block',
  overflow: 'hidden',
  '@lg': {
    borderRadius: '$r2',
  },
})

type LandscapeImageCustomProps = {
  title?: string
  url?: LinkFieldType
  image?: MediaFieldType
}

export const SectionLandscapeImage: FC<LandscapeImageCustomProps> = ({
  title,
  url,
  image,
}) => {
  return (
    <SectionWrap>
      <Root>
        {title && <Title>{title}</Title>}
        {url?.href ? (
          <a href={url.href}>
            <ImageContainer>
              <StyledMedia>
                {image && (
                  <Media layout={'responsive'} objectFit={'cover'} {...image} />
                )}
              </StyledMedia>
            </ImageContainer>
          </a>
        ) : (
          <ImageContainer>
            <StyledMedia>
              {image && (
                <Media layout={'responsive'} objectFit={'cover'} {...image} />
              )}
            </StyledMedia>
          </ImageContainer>
        )}
      </Root>
    </SectionWrap>
  )
}
